import { z } from 'zod';
/**
 * How a manual job stopped being outstanding. Orchestrator owns the job record; primary states the
 * vocabulary because it resolves jobs on a user's behalf and proxies the rest of the surface.
 */
export var ManualJobResolution;
(function (ManualJobResolution) {
    ManualJobResolution["Canceled"] = "CANCELED";
    ManualJobResolution["Completed"] = "COMPLETED";
    ManualJobResolution["Expired"] = "EXPIRED";
    ManualJobResolution["Superseded"] = "SUPERSEDED";
})(ManualJobResolution || (ManualJobResolution = {}));
export const ManualJobResolutionSchema = z.enum(ManualJobResolution);
//# sourceMappingURL=resolution.js.map